import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-simple-border-wrapper',
  templateUrl: './simple-border-wrapper.component.html',
  styleUrls: ['./simple-border-wrapper.component.scss'],
  imports: [CommonModule, TranslateModule]
})
export class SimpleBorderWrapperComponent extends FieldWrapper {

  constructor() {
    super()
   }

}
